import styled from 'styled-components';

export const App = styled.div`
  display: flex;
  position: relative ;
  flex-direction: column;
  width: 100vw ;
  height: 90vh;
  margin-top:50px ;
  background-color: #2b2b2b;
  overflow: hidden ; 
  font-size: clamp(11px, 3vw, 16px);
  align-items: center ;

  button{
    cursor: pointer;
    border:none;
  }
`

export const body = styled.div`
display: flex;
position: relative ;
flex-direction: column ; 
align-items: center ;
background-color: black;
width: 100vw ;
max-width: 500px ;
height: 90vh ;
padding: 0 10px ;

`
// -----------------------------
export const VistoriaModal = styled.div`
display: flex ;
flex-direction: column ;
`

// ------------------------------
export const Modal = styled.div`
display: flex ;
overflow:auto ;
`
// ------------------------------------------
export const div3 = styled.div` 
display:flex;
flex-direction: column ;
color: #00D594;
align-items: center ;

.spanBranco{
  margin:0px ;
  color: white ;
}

.novoCad{
  color: black ;
  background-color: white ;
  padding: 1px 3px ;
  cursor: pointer;
}

.maiusculo{
  text-transform:capitalize
}
.uppercase{
  text-transform:uppercase
};

.intemSelect{
  display: flex ;
  align-items: center ;
  height: 30px ;
  background-color: #30353F;
  color: white ;
  min-height: 25px ;
  cursor: pointer;
  padding-left: 5px ;
  text-transform:capitalize;
};
.intem{
  display: flex ;
  color: #d8e5ffff;
}

.EditarSelect{
  display: flex ;
  flex:1 ;
  flex-direction: column ;
  margin: 0 5px ;
}
`
// ----------------------------------


